/**
 * Express Payment Methods Resource Client
 * Axios-based API client for express payment methods
 */

import { ApiClient } from './apiClient';

export interface PaymentMethod {
    id: string;
    type: string;
    title: string;
    iconUrl: string;
    default: boolean;
    settings?: Record<string, unknown>;
    metadata?: Record<string, unknown>;
}

export interface Address {
    address1: string;
    address2?: string;
    lastName?: string;
    firstName?: string;
    city?: string;
    state?: string;
    country?: string;
    postal?: string;
    phone?: string;
    email?: string;
}

export interface UpdateAddressRequest {
    data: {
        shippingAddress: Address;
        billingAddress?: Address | null;
    };
}

export interface UpdateCustomerEmailRequest {
    data: {
        email: string;
    };
}

export class ExpressPaymentMethodsResource {
    constructor(private apiClient: ApiClient) { }

    /**
     * Get enabled payment methods for a checkout session
     */
    async getPaymentMethods(sessionId: string): Promise<PaymentMethod[]> {
        return this.apiClient.get(`/api/v1/payment-methods?checkoutSessionId=${encodeURIComponent(sessionId)}`);
    }

    /**
     * Update checkout session address (for express checkout flows)
     */
    async updateCheckoutSessionAddress(
        sessionId: string,
        data: UpdateAddressRequest
    ): Promise<{ success: boolean }> {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/address`, data);
    }

    /**
     * Update customer email
     */
    async updateCustomerEmail(
        customerId: string,
        data: UpdateCustomerEmailRequest
    ): Promise<{ success: boolean }> {
        return this.apiClient.post(`/api/v1/customers/${customerId}`, data);
    }
}

